import React from 'react';
import { connect } from 'react-redux';
import { fetchReclamationCausesPrincipales } from 'utils/fetchers';
import { fetchReclamationMotifsResolution } from 'utils/fetchers';
import ClotureContent from './ClotureContent';
import withLoader from 'components/Shared/withLoader';

const ClotureContentWithLoader = withLoader(ClotureContent);

const Namespace = 'clotureReclamationInAction';

class ClotureContentContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            motifsResolutionEtMessage: [],
            causesPrincipales: [],
            isLoading: true
        };
    }

    async componentDidMount() {
        const { reclamationId } = this.props;

        var motifsResolutionEtMessage = await this.props.fetchReclamationMotifsResolution(reclamationId);
        var causesPrincipales = await this.props.fetchReclamationCausesPrincipales(reclamationId);

        this.setState({ motifsResolutionEtMessage: motifsResolutionEtMessage, causesPrincipales: causesPrincipales, isLoading: !motifsResolutionEtMessage || !causesPrincipales });
    }

    render() {
        const { reclamationId, withDropzone, autoFocus, onChange } = this.props;
        const { isLoading, motifsResolutionEtMessage, causesPrincipales } = this.state;

        let motifsResolution = [];
        let motifsResolutionMessage = '';
        if (motifsResolutionEtMessage) {
            motifsResolution = motifsResolutionEtMessage.motifsResolution;
            motifsResolutionMessage = motifsResolutionEtMessage.message;
        }

        return (
            <ClotureContentWithLoader
                isLoading={isLoading}
                reclamationId={reclamationId}
                onChange={onChange}
                namespace={Namespace}
                motifsResolution={motifsResolution}
                motifsResolutionMessage={motifsResolutionMessage}
                causesPrincipales={causesPrincipales}
                withDropzone={withDropzone}
                autoFocus={autoFocus}
            />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    fetchReclamationMotifsResolution: (reclamationId) => dispatch(fetchReclamationMotifsResolution(reclamationId)),
    fetchReclamationCausesPrincipales: (reclamationId) => dispatch(fetchReclamationCausesPrincipales(reclamationId))    
});

export default connect(null, mapDispatchToProps)(ClotureContentContainer);